module.exports = __webpack_public_path__ + "static/media/kitchen5.13d50a20.jpg";